import { useRouter } from 'next/compat/router';
import usePaths from 'hooks/use-paths';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import { setConciergeReferrer } from 'src/concierge/concierge-referrer';

export const useConciergeNavigate = (): (() => void) => {
  const router = useRouter();
  const { href } = usePaths();
  const { dispensary } = useDispensary();

  return () => {
    setConciergeReferrer(router?.asPath, dispensary?.id);
    void router?.push(`${href}/concierge`);
  };
};
